import { Directive, DestroyRef, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '../libs/auth/auth.service';

@Directive({
	selector: '[btHasRole]',
	standalone: true
})
export class HasRoleDirective {
	readonly #authService = inject(AuthService);
	readonly #viewContainer = inject(ViewContainerRef);
	readonly #templateRef = inject(TemplateRef<any>);
	readonly #destroyRef = inject(DestroyRef);

	#requiredRoles: Array<string> = [];

	constructor() {
		this.#authService.getUserLogged.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(() => this.updateView());
	}

	@Input('btHasRole') set roles(requiredRoles: Array<string>) {
		this.#requiredRoles = requiredRoles ?? [];
		this.updateView();
	}

	private updateView(): void {
		const userRoles = this.#authService.userLoggedValue?.Roles ?? [];
		const hasPermission = this.#requiredRoles.length === 0 || this.#requiredRoles.some((role) => userRoles.includes(role));

		this.#viewContainer.clear();
		if (hasPermission) {
			this.#viewContainer.createEmbeddedView(this.#templateRef);
		}
	}
}
